module.exports = __webpack_public_path__ + "static/img/8.0fda97a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/8.png
// module id = PPQI
// module chunks = 0